export default {
      id: "preferences-usage",
      viewBox: "0 0 640 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#preferences",
      toString: function () {
        return this.url;
      }
    }